export const display_services_count = process.env.REACT_APP_DISPLAY_SERVICES_COUNT || 20;